import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Subject } from 'rxjs';

import { RoutesUtilsService } from '@vfde-fe/ngx-lib/services/routes-utils';

/** RouterService */
@Injectable({
  providedIn: 'root',
})
export class RouterService {
  /** _currentModule */
  private _currentModule = '';
  /** _previousExist */
  private _previousExist = false;
  /** backBtnPressed */
  public backBtnPressed = false;
  /** header change */
  public headerChange: Subject<void>;

  public constructor (
    private router: Router,
    private routesUtilsService: RoutesUtilsService,
    private location: Location,
  ) {
    this.headerChange = new Subject<void>();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (
          this.routesUtilsService.getHistoryUrl() &&
          this.routesUtilsService.getHistoryUrl().currentURL &&
          !this.routesUtilsService.getHistoryUrl().currentURL.includes('#')
        ) {
          this._previousExist = true;
        }
      } else if (event instanceof NavigationEnd) {
        if (!this.routesUtilsService.getHistoryUrl().currentURL.includes('#')) {
          // set application page history
          const backBtnTriggered =
            this.routesUtilsService.getHistoryUrl().previousUrl === event.url;
          const historyUrl = {
            previousUrl: this.routesUtilsService.getHistoryUrl().currentURL,
            currentURL: event.url,
            currentStep: -1,
          };
          this.routesUtilsService.setHistoryUrl(historyUrl)
        }
      }
    });
  }

  /** setCurrentModule */
  public setCurrentModule (currentModule: string): void {
    this._currentModule = currentModule;
  }
  /** getCurrentModule */
  public getCurrentModule (): string {
    return this._currentModule;
  }

  /** previousExist */
  public get previousExist (): boolean {
    return this._previousExist;
  }

  /**
   * Takes the path of the title to be setted and changes the titleKey's default value
   * @param titlePath - path of the the object to be setted
   * @param titleKey - new titleKey to be setted
   */
  public setDefaultTitle (titlePath: any, titleKey: string) {
    titlePath.titleKey.DEFAULT = titleKey;
    this.headerChange.next();
  }

}
